import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/plogo.png';
import bgImage from '../assets/bg1.jpg'; // Ensure this path is correct

const styles = {
    container: {
        margin: 0,
        padding: 0,
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Inter, sans-serif",
        position: 'relative',
        boxSizing: 'border-box',
        // --- BACKGROUND UPDATED HERE ---
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000', // Fallback color
    },
    formBox: {
        background: "rgba(255, 255, 255, 0.95)", // Added slight transparency for better blending
        borderRadius: "16px",
        padding: "40px 30px",
        boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
        width: "90%",
        maxWidth: "420px",
        boxSizing: 'border-box',
        marginTop: '60px',
        zIndex: 2, // Ensure form stays above background
    },
    input: {
        width: "100%",
        padding: "14px 16px",
        borderRadius: "9999px",
        border: "1px solid #ddd",
        marginBottom: "1.2rem",
        fontSize: "0.95rem",
        backgroundColor: "#f8faff",
        outline: "none",
        transition: "all 0.2s ease-in-out",
        boxSizing: 'border-box',
    },
    label: {
        marginBottom: "6px",
        display: "block",
        fontSize: "0.9rem",
        fontWeight: "500",
        color: "#444",
    },
    button: {
        width: "100%",
        padding: "14px",
        backgroundColor: "#AE7D54",
        color: "#fff",
        border: "none",
        borderRadius: "9999px",
        fontSize: "1rem",
        fontWeight: "bold",
        cursor: "pointer",
        marginTop: "10px",
        boxShadow: "0 4px 10px rgba(174, 125, 84, 0.3)",
        transition: "background-color 0.2s ease-in-out",
    },
    headerStyle: {
        position: 'absolute',
        top: '0',
        left: '0',
        padding: '32px',
        zIndex: 10,
    },
    logoStyle: {
        width: '150px', 
        height: 'auto', 
        objectFit: 'contain',
    },
    messageBox: {
        marginTop: '1rem',
        textAlign: 'center',
        fontSize: '0.875rem',
    },
    errorText: {
        color: '#dc2626',
    },
    successText: {
        color: '#16a34a',
    },
    loginHeading: {
        textAlign: 'center',
        color: '#000',
        marginBottom: '20px',
        fontSize: '1.8rem',
        fontWeight: '600',
    }
};

function App() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage('');
        setMessageType('');

        if (username && password) {
            try {
                const response = await fetch('https://admin.theporch.in/api/login', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ username, password }),
                });
                const data = await response.json();

                if (response.ok) {
                    setMessage('Login successful! Redirecting to dashboard...');
                    setMessageType('success');
                    localStorage.setItem('isLoggedIn', 'true');
                    setTimeout(() => {
                        navigate('/dashboard');
                    }, 500);
                } else {
                    setMessage(data.error || 'Login failed. Please check your credentials.');
                    setMessageType('error');
                }
            } catch (error) {
                setMessage('An error occurred. Please try again later.');
                setMessageType('error');
            }
        } else {
            setMessage('Please fill in all fields.');
            setMessageType('error');
        }
    };

    return (
        <>
            <style>
                {`
                html, body {
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    height: 100%;
                    overflow-x: hidden;
                }

                .login-container {
                    background-image: url(${bgImage});
                }
                
                /* Responsive Background handling */
                @media (max-width: 768px) {
                    .login-container {
                        background-image: linear-gradient(135deg, #000000 0%, #2c3e50 100%) !important;
                    }
                }
                `}
            </style>

            <div className="login-container" style={styles.container}>
                <header style={styles.headerStyle}>
                    <img src={logo} alt="The Pride Logo" style={styles.logoStyle} />
                </header>

                <div style={styles.formBox}>
                    <h2 style={styles.loginHeading}>Log In</h2>
                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '1.2rem' }}>
                            <label htmlFor="username" style={styles.label}>Username*</label>
                            <input
                                type="text"
                                id="username"
                                name="username"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                style={{ ...styles.input, marginBottom: 0 }}
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '1.2rem' }}>
                            <label htmlFor="password" style={styles.label}>Password*</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{ ...styles.input, marginBottom: 0 }}
                                required
                            />
                        </div>
                        <button type="submit" style={styles.button}>Continue</button>
                    </form>

                    {message && (
                        <div
                            style={{
                                ...styles.messageBox,
                                ...(messageType === 'error' ? styles.errorText : styles.successText)
                            }}
                        >
                            {message}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default App;